export const TeamPermissions = {

    ViewTeam: {
        permissionsId: '71409199-3ca0-4c0e-e7cb-08d96ae283eb',
        permissionsName: 'View Team',
        componentsId: null,
        components: null
    },
    AddRecordCard: {
        permissionsId: '227a804c-0822-45e7-e7cc-08d96ae283eb',
        permissionsName: 'Add Record Card',
        componentsId: null,
        components: null
    },
    DeleteRecordCard: {
        permissionsId: 'bdab9575-d647-4959-e7cd-08d96ae283eb',
        permissionsName: 'Delete Record Card',
        componentsId: null,
        components: null
    },
    EditRecordCard: {
        permissionsId: '23dd3f54-3fbd-4c84-e7ce-08d96ae283eb',
        permissionsName: 'Edit Record Card',
        componentsId: null,
        components: null
    }

};
